import { IAddBmiPayload, IPagination } from "@interfaces";
import axiosClient from "./axiosClient";

export const bmiApi = {
    addBmi: (values: IAddBmiPayload) => {
        const url = "/bmi";
        return axiosClient.post(url, values);
    },
    getMyBmiRecords: (params: IPagination) => {
        const url = "/bmi/my-records";
        return axiosClient.get(url, { params });
    },
};
